'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _recompose = require('recompose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOGO_RATIO = 370 / 920;
var LINE_THICKNESS_RATIO = 30 / 920;
var DEFAULT_SIZE = 60;

var enhance = (0, _recompose.defaultProps)({
    size: DEFAULT_SIZE,
    strokeWidth: DEFAULT_SIZE * LINE_THICKNESS_RATIO,
    color: '#f4511c',
    animate: true
});

var getLogoPath = function getLogoPath(size) {
    var logoSize = size * LOGO_RATIO;
    var offset = size / 2 - logoSize / 2;

    var x1 = 0 + offset;
    var y1 = 0 + offset;

    var x2 = 0 + offset;
    var y2 = logoSize + offset;

    var x3 = logoSize + offset;
    var y3 = logoSize + offset;

    var x4 = logoSize + offset;
    var y4 = 0 + offset;

    return 'M ' + x1 + ' ' + y1 + ' L ' + x2 + ' ' + y2 + ' L ' + x3 + ' ' + y3 + ' L ' + x4 + ' ' + y4 + ' L ' + x2 + ' ' + y2 + ' M ' + x1 + ' ' + y1 + ' L ' + x3 + ' ' + y3;
};

var getViewBox = function getViewBox(size) {
    return '0 0 ' + size + ' ' + size;
};

var MilanoteLogo = function MilanoteLogo(_ref) {
    var size = _ref.size,
        strokeWidth = _ref.strokeWidth,
        animate = _ref.animate,
        color = _ref.color;
    return _react2.default.createElement(
        'div',
        { className: 'MilanoteLogo', style: { position: 'relative', width: size, height: size } },
        _react2.default.createElement(
            'svg',
            { viewBox: getViewBox(size),
                width: size,
                height: size,
                style: { position: 'absolute' },
                className: 'path logo-spinner-circle' },
            _react2.default.createElement('circle', { cx: size / 2,
                cy: size / 2,
                r: size / 2 - strokeWidth,
                fill: 'none',
                strokeWidth: strokeWidth,
                strokeMiterlimit: '10',
                stroke: color })
        ),
        _react2.default.createElement(
            'svg',
            { viewBox: getViewBox(size),
                width: size,
                height: size, style: { position: 'absolute' },
                className: (0, _classnames2.default)('logo-spinner-icon', { animate: animate }) },
            _react2.default.createElement('path', { d: getLogoPath(size),
                strokeWidth: strokeWidth,
                stroke: color,
                fill: 'none',
                strokeLinecap: 'round',
                strokeLinejoin: 'round' })
        )
    );
};

MilanoteLogo.propTypes = {
    size: _propTypes2.default.number,
    strokeWidth: _propTypes2.default.number,
    color: _propTypes2.default.string,
    animate: _propTypes2.default.bool
};

exports.default = enhance(MilanoteLogo);


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/MilanoteLogo.js
// module id = 1783
// module chunks = 0